// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"170c1d13","187":"69208462","234":"3e60f873","589":"74d4ad0a","666":"a2f07552","680":"948bc72c","727":"d6fd3d73","794":"ffdadd24","849":"1543e101"}[chunkId] + ".chunk.js";
};